// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3m6rY","expireSoon":"styles_expireSoon__VHiwN"};